import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import img1 from "../assets/Nfts/art3.webp";
import img2 from "../assets/Nfts/art2.webp";
import img3 from "../assets/Nfts/art4.webp";
import img4 from "../assets/Nfts/art1.webp";
import img5 from "../assets/Nfts/cover2.webp";
import img6 from "../assets/Nfts/cover1.webp";
import img7 from "../assets/Nfts/neon2.webp";
import img8 from "../assets/Nfts/photo1.webp";
import img9 from "../assets/Nfts/cover5.webp";
import img10 from "../assets/Nfts/cover3.webp";
import img11 from "../assets/Nfts/cover4.webp";
import img12 from "../assets/Nfts/col3.webp";
import img13 from "../assets/Nfts/download (5).jpg";
import img14 from "../assets/Nfts/download (6).jpg";
import img15 from "../assets/Nfts/download (6).jpg";
import img16 from "../assets/Nfts/download (10).jpg";
import img17 from "../assets/Nfts/PINTEREST.jpg";
import img18 from "../assets/Nfts/space1.webp";
import img19 from "../assets/Nfts/5052_eth.jpg";
import img20 from "../assets/Nfts/bighead-7.svg";
import ETH from "../assets/icons8-ethereum-48.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { getAllArts } from "../lib/actions";
import { Query } from "appwrite";
import { getMediaElement } from "../components/GetMediaElement";

const Section = styled.section`
  min-height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.text};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  .scrolling {
    animation-duration: 30s;
    @media (max-width: 30em) {
      animation-duration: 15s;
    }
  }
  //   & > *:last-child {
  //     animation-duration: 30s;
  //     @media (max-width: 30em) {
  //       animation-duration: 15s;
  //     }
  //   }
`;
const move = keyframes`
    0%{ transform: translateX(0)   };
    100%{ transform: translateX(-50%)   }
`;

const Row = styled.div`
  /* background-color: lightblue; */
  white-space: nowrap;
  box-sizing: content-box;
  margin: 2rem 0;
  display: flex;

  animation: ${move} linear infinite;
  animation-direction: ${(props) => props.direction};

  & > * {
    flex-shrink: 0;
  }
`;

const ImgContainer = styled.div`
  width: 26rem;
  margin: 0 1rem;

  border-radius: 20px;
  cursor: pointer;

  @media (max-width: 48em) {
    width: 20rem;
  }
  @media (max-width: 30em) {
    width: 20rem;
  }

  img {
    width: 100%;
    height: 500px;
    border-radius: 20px 20px 0 0;
  }
`;

const Details = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 1rem;
  background-color: ${(props) => props.theme.text};
  border: 2px solid ${(props) => `rgba(${props.theme.bodyRgba},0.5)`};

  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  span {
    font-size: ${(props) => props.theme.fontsm};
    color: ${(props) => `rgba(${props.theme.bodyRgba},0.5)`};
    font-weight: 600;
    line-height: 1.5rem;
  }

  h1 {
    font-size: ${(props) => props.theme.fontmd};
    color: ${(props) => props.theme.body};
    font-weight: 600;

    @media (max-width: 30em) {
      font-size: ${(props) => props.theme.fontsm};
    }
  }
`;

const Price = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 1rem;
    height: auto;
  }
`;

const Search = styled.input`
  width: 100%;
  margin: 1rem auto;
  padding: 1rem;
  border-radius: 1rem;
  background-color: ${(props) => props.theme.body};
  // position: sticky;
  top: 0%;
  border: 2px solid ${(props) => props.theme.text};
`;

const Dropdown = styled.div`
  position: absolute;
  top: 5rem;
  width: 80%;
  max-height: 300px;
  overflow-y: auto;
  background-color: ${(props) => props.theme.body};
  border: 2px solid ${(props) => props.theme.text};
  border-radius: 1rem;
  z-index: 10;
`;

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-bottom: 1px solid ${(props) => props.theme.text};
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.text};
    color: ${(props) => props.theme.body};
  }

  img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 0.5rem;
    margin-right: 1rem;
  }

  span {
    font-weight: 600;
  }
`;
const NftItem = ({
  img,
  number = 0,
  price = 0,
  name = "Trade Millennia",
  owner = "",
  ownerImg = "https://i.pravatar.cc/40",
  description = "",
  wallet_address,
  passRef,
  art,
}) => {
  let play = (e) => {
    passRef.current.style.animationPlayState = "running";
  };
  let pause = (e) => {
    passRef.current.style.animationPlayState = "paused";
  };

  var mediaType;
  if (art && art.length > 0) {
    mediaType = art[0].mediaType;
  }
  return (
    <Link
      to={`/nft/${number}`}
      state={{
        img,
        number: name,
        price,
        owner,
        ownerImg,
        description,
        wallet_address,
        art,
      }}
      style={{ textDecoration: "none" }}
    >
      <ImgContainer onMouseOver={(e) => pause(e)} onMouseOut={(e) => play(e)}>
        {mediaType === "audio" ? (
          <div
            style={{
              width: "100%",
              height: "500px",
              aspectRatio: "1 / 1",
              overflow: "hidden",
              borderRadius: "0.5rem 0.5rem 0 0",
              background: "#0f0f0f",
              position: "relative",
            }}
          >
            {getMediaElement(art[0])}
          </div>
        ) : (
          <img width={800} height={600} src={img} alt="Trade Millennia" />
        )}
        <Details>
          <div>
            <span>{name}</span> <br />
            <h1>#{number}</h1>
            <p
              style={{
                fontSize: "0.8rem",
                color: "orange",
                "margin-top": "10px",
              }}
            >
              {" "}
              Buy Now
            </p>
          </div>

          <div>
            <span>Price</span>
            <Price>
              <img width={200} height={200} src={ETH} alt="ETH" />
              <h1>{Number(price).toFixed(1)}</h1>
            </Price>
          </div>
        </Details>
      </ImgContainer>
    </Link>
  );
};

const ExplorePage = () => {
  const imagesRow1 = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img11,
    img13,
    img15,
    img17,
    img19,
  ];
  const imagesRow2 = [
    img6,
    img7,
    img8,
    img9,
    img10,
    img12,
    img14,
    img16,
    img18,
    img20,
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (!value) {
      setSearchResults([]);
      return;
    }

    // Filter by name (case-insensitive)
    const results = items.filter(
      (item) =>
        item.name && item.name.toLowerCase().includes(value.toLowerCase()),
    );

    setSearchResults(results.slice(0, 5)); // Limit dropdown to 5 results
  };

  const navigate = useNavigate();

  const handleSelectItem = (item) => {
    navigate(`/nft/${item.id}`, {
      state: {
        img: `https://api.trevomint.com/v1/${item.file}`,
        number: item.name,
        price: item.price === "" ? 1 : item.price,
        owner: item.username || "Trade Millennia",
        ownerImg: `https://api.trevomint.com/v1/${item.image}`,
      },
    });
  };

  const Row1Ref = useRef(null);

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        const allArts = await getAllArts([Query.equal("minted", true)]);
        const response = await fetch("https://api.trevomint.com/v1/explore");

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setItems([...allArts, ...data]);
        console.log(allArts);
      } catch (err) {
        console.error(err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // Split array into chunks of 10
  const splitIntoChunks = (arr, chunkSize = 10) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  };

  const padOrTrim = (arr, count) => {
    if (arr.length >= count) return arr.slice(0, count);
    while (arr.length < count) arr = arr.concat(arr);
    return arr.slice(0, count);
  };

  const rows = loading
    ? [imagesRow1, imagesRow2, imagesRow1, imagesRow2]
    : splitIntoChunks(items, 10).map((chunk) => padOrTrim(chunk, 10));

  if (error) return <p>{error}</p>;

  return (
    <Section id="showcase">
      <Navigation />
      <div style={{ position: "relative", width: "80%", margin: "1rem auto" }}>
        <Search
          value={searchTerm}
          placeholder="Search art Here"
          onChange={handleSearchChange}
        />

        {searchResults.length > 0 && (
          <Dropdown>
            {searchResults.map((item) => (
              <DropdownItem
                key={item.id}
                onClick={() => handleSelectItem(item)}
              >
                <img
                  src={`https://api.trevomint.com/v1/${item.file}`}
                  alt={item.name}
                />
                <div>
                  <span>{item.name}</span>
                  <br />
                  <small>Ξ {item.price === "" ? 1 : item.price}</small>
                </div>
              </DropdownItem>
            ))}
          </Dropdown>
        )}
      </div>

      {rows.map((rowItems, rowIndex) => {
        const direction = rowIndex % 2 === 0 ? "none" : "reverse";
        // const rowRef = useRef(null);
        const isLoadingFallback = loading;

        return (
          <Row
            className="scrolling"
            direction={direction}
            ref={Row1Ref}
            key={rowIndex}
          >
            {rowItems
              .concat(rowItems)
              .map((item, index) =>
                isLoadingFallback ? (
                  <NftItem
                    img={item}
                    number={852 + index}
                    price={1 + index * 0.2}
                    owner="Trade Millennia"
                    ownerImg="https://i.pravatar.cc/40"
                    passRef={Row1Ref}
                    key={index}
                  />
                ) : (
                  <NftItem
                    img={
                      item.img ?? `https://api.trevomint.com/v1/${item.file}`
                    }
                    number={item.id || index + 1}
                    name={item.name}
                    price={item.price === "" ? 1 : item.price}
                    owner={
                      item.userId?.username ||
                      item.username ||
                      "Trade Millennia"
                    }
                    ownerImg={`https://api.trevomint.com/v1/${item.image}`}
                    description={item.description}
                    wallet_address={item.userId?.wallet_address}
                    passRef={Row1Ref}
                    key={index}
                    art={item.img ? [item] : null}
                  />
                ),
              )}
          </Row>
        );
      })}
      <Footer />
    </Section>
  );
};

export default ExplorePage;
